var _path, _rect, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileViewFeatureConnectors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 451,
    viewBox: "0 0 188 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 2V42.058C85 48.6854 79.6274 54.058 73 54.058H13C6.37258 54.058 1 59.4306 1 66.058V451",
    stroke: "#2F69DE",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    width: 6,
    height: 27,
    rx: 3,
    fill: "#2F69DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103 2V42.058C103 48.6854 108.373 54.058 115 54.058H175C181.627 54.058 187 59.4306 187 66.058V451",
    stroke: "#F19708",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.00007,
    height: 27,
    rx: 3.00003,
    transform: "matrix(-1 0 0 1 106 0)",
    fill: "#F19708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileViewFeatureConnectors);
export default __webpack_public_path__ + "static/media/mobile-view-feature-connectors.94dd52c33bf9c22806f3026a851b2ba0.svg";
export { ForwardRef as ReactComponent };